import { useEffect, useRef } from "react";

import { inject, observer } from "mobx-react";
import { Toast } from "primereact/toast";

import "./style.scss";

const ToastUI = inject("mainStore")(
    observer(({ mainStore }) => {
        const toast = mainStore.getMainStore("toast");
        const toastRef = useRef(null);

        useEffect(() => {
            if (toast) {
                toastRef.current.show(toast);
                mainStore.setMainStore("toast", false);
            }
        }, [toast]);

        return <Toast ref={toastRef} className="toast-ui" />;
    }),
);

export default ToastUI;
